{
  "entityId": {
    "type": "string",
    "title": "Individnummer",
    "description": "Fyll inn individnummeret på 12, 5 eller 4 siffer. Bruk helst alle 12 sifrene hvis det er mulig.",
    "pattern": "([0-9]{4}|[0-9]{5}|[0-9]{12})",
    "maxLength": 12
  },
  "entityUELNId": {
    "type": "string",
    "title": "Individnummer (UELN)",
    "description": "Fyll inn UELN-nummer på 15 siffer.",
    "minLength": 15,
    "maxLength": 15,
    "pattern": "[0-9]*"
  },
  "flockId": {
    "type": "string",
    "title": "Flokk ID",
    "description": "Fyll inn flokk ID på 6 siffer.",
    "minLength": 6,
    "maxLength": 6,
    "pattern": "[0-9]*"
  },
  "houseId": {
    "type": "string",
    "title": "Hus ID",
    "description": "Fyll inn hus ID.",
    "minLength": 1,
    "maxLength": 200
  },
  "gender": {
    "type": "string",
    "title": "Kjønn",
    "description": "Velg dyrets kjønn. Velg “ukjent” kun når du ikke kan finne svaret.",
    "oneOf": [
      { "const": "Male", "title": "Hann" },
      { "const": "Female", "title": "Hunn" },
      { "const": "Unknown", "title": "Ukjent" }
    ]
  },
  "pregnant": {
    "type": "string",
    "title": "Drektig",
    "description": "Velg om dyret var drektig eller ikke ved prøveuttak. Velg “ukjent” kun når du ikke kan finne svaret.",
    "oneOf": [
      { "const": "No", "title": "Nei" },
      { "const": "Yes", "title": "Ja" },
      { "const": "Unknown", "title": "Ukjent" }
    ]
  },
  "birthLastFourWeeks": {
    "type": "string",
    "title": "Fødsel siste 4 uker",
    "description": "Velg om dyret har født de siste 4 ukene før prøveuttak. Velg “ukjent” kun når du ikke kan finne svaret.",
    "oneOf": [
      { "const": "No", "title": "Nei" },
      { "const": "Yes", "title": "Ja" },
      { "const": "Unknown", "title": "Ukjent" }
    ]
  },
  "conditionAtSampling": {
    "type": "string",
    "title": "Tilstand ved prøveuttak",
    "description": "Velg om dyret var død eller levende ved uttak av prøven.",
    "oneOf": [
      { "const": "Dead", "title": "Død" },
      { "const": "Alive", "title": "Levende" }
    ]
  },
  "countryOfOrigin": {
    "type": "string",
    "title": "Opprinnelsesland",
    "description": "Landskoden følger ISO 3166-1 alpha-2.",
    "pattern": "^[A-Z]{2}$",
    "oneOf": [
      { "const": "NO", "title": "Norge (NO)" },
      { "const": "SE", "title": "Sverige (SE)" },
      { "const": "DK", "title": "Danmark (DK)" },
      { "const": "FI", "title": "Finland (FI)" },
      { "const": "IS", "title": "Island (IS)" },
      { "const": "EE", "title": "Estland (EE)" },
      { "const": "LV", "title": "Latvia (LV)" },
      { "const": "LT", "title": "Litauen (LT)" },
      { "const": "PL", "title": "Polen (PL)" },
      { "const": "DE", "title": "Tyskland (DE)" },
      { "const": "NL", "title": "Nederland (NL)" },
      { "const": "BE", "title": "Belgia (BE)" },
      { "const": "FR", "title": "Frankrike (FR)" },
      { "const": "GB", "title": "Storbritannia (GB)" },
      { "const": "IT", "title": "Italia (IT)" },
      { "const": "ES", "title": "Spania (ES)" },
      { "const": "PT", "title": "Portugal (PT)" }
    ]
  },
  "age": {
    "type": "integer",
    "title": "Alder",
    "description": "Fyll inn alderen til dyret. Du kan velge mellom alder i dager eller måneder. Pass på at du har valgt riktig benevning.",
    "minimum": 5,
    "maximum": 9999,
    "examples": [5, 30, 365, 720]
  },
  "treatmentLastFourWeeks": {
    "type": "string",
    "title": "Behandling siste 4 uker",
    "description": "Velg om dyret har fått behandling de siste 4 ukene. Ved behandling må gitt behandling også fylles ut. Velg “ukjent” kun når du ikke kan finne svaret.",
    "oneOf": [
      { "const": "No", "title": "Nei" },
      { "const": "Yes", "title": "Ja" },
      { "const": "Unknown", "title": "Ukjent" }
    ]
  },
  "treatmentDescription": {
    "type": "string",
    "title": "Beskriv behandling",
    "description": "Fyll ut hvilken behandling dyret har fått i løpet av de siste 4 ukene.",
    "maxLength": 500
  },
  "organicProduction": {
    "type": "string",
    "title": "Økologisk produksjon",
    "description": "Velg om det som er prøvetatt kommer fra økologisk produksjon.",
    "oneOf": [
      { "const": "No", "title": "Nei" },
      { "const": "Yes", "title": "Ja" }
    ]
  },
  "skrottlappScan": {
    "$ref": "#/definitions/skrottlappScanStorfe"
  },
  "skrottlappScanStorfe": {
    "type": "object",
    "title": "Skrottlapp (storfe)",
    "description": "Ved å scanne skrottlappen vil noen av feltene i skjemaet utfylles automatisk, resten kan fylles ut manuelt. Scan den nederste strekkoden hvis skrottlappen har to strekkoder. Husk å sjekke at informasjonen stemmer.",
    "properties": {
      "eftakode": {
        "type": "string",
        "title": "EFTA-nummer"
      },
      "slaktedato": {
        "type": "string",
        "title": "Slaktedato"
      },
      "skrottnummer": {
        "type": "string",
        "title": "Skrottnummer"
      },
      "varenummer": {
        "type": "string",
        "title": "Varenummer"
      },
      "leieslakt": {
        "type": "string",
        "title": "Leieslakt"
      },
      "foedeland": {
        "type": "string",
        "title": "Fødeland"
      },
      "individnummer": {
        "type": "string",
        "title": "Individnummer"
      },
      "alder": {
        "type": "string",
        "title": "Alder (dager)"
      },
      "rase": {
        "type": "string",
        "title": "Rase"
      },
      "srm": {
        "type": "string",
        "title": "SRM"
      }
    }
  },
  "skrottlappScanSvin": {
    "type": "object",
    "title": "Skrottlapp (svin)",
    "description": "Ved å scanne skrottlappen vil noen av feltene i skjemaet utfylles automatisk, resten kan fylles ut manuelt. Scan den nederste strekkoden hvis skrottlappen har to strekkoder. Husk å sjekke at informasjonen stemmer.",
    "properties": {
      "eftakode": {
        "type": "string",
        "title": "EFTA-nummer"
      },
      "slaktedato": {
        "type": "string",
        "title": "Slaktedato"
      },
      "skrottnummer": {
        "type": "string",
        "title": "Skrottnummer"
      },
      "varenummer": {
        "type": "string",
        "title": "Varenummer"
      },
      "leieslakt": {
        "type": "string",
        "title": "Leieslakt"
      },
      "foedeland": {
        "type": "string",
        "title": "Fødeland"
      },
      "individnummer": {
        "type": "string",
        "title": "Individnummer"
      }
    }
  },
  "skrottlappScanSau": {
    "type": "object",
    "title": "Skrottlapp (sau)",
    "description": "Ved å scanne skrottlappen vil noen av feltene i skjemaet utfylles automatisk, resten kan fylles ut manuelt. Scan den nederste strekkoden hvis skrottlappen har to strekkoder. Husk å sjekke at informasjonen stemmer.",
    "properties": {
      "eftakode": {
        "type": "string",
        "title": "EFTA-nummer"
      },
      "slaktedato": {
        "type": "string",
        "title": "Slaktedato"
      },
      "skrottnummer": {
        "type": "string",
        "title": "Skrottnummer"
      },
      "varenummer": {
        "type": "string",
        "title": "Varenummer"
      },
      "leieslakt": {
        "type": "string",
        "title": "Leieslakt"
      },
      "foedeland": {
        "type": "string",
        "title": "Fødeland"
      },
      "individnummer": {
        "type": "string",
        "title": "Individnummer"
      }
    }
  },
  "skrottlappScanRein": {
    "type": "object",
    "title": "Skrottlapp (rein)",
    "description": "Ved å skanne skrottlappen fylles tilgjengelige opplysninger ut automatisk. Kontroller opplysningene og velg reinbeitedistrikt manuelt hvis det ikke kan slås opp.",
    "properties": {
      "eftakode": { "type": "string", "title": "EFTA-nummer" },
      "slaktedato": { "type": "string", "title": "Slaktedato" },
      "skrottnummer": { "type": "string", "title": "Skrottnummer" },
      "varenummer": { "type": "string", "title": "Varenummer" },
      "leieslakt": { "type": "string", "title": "Leieslakt" },
      "foedeland": { "type": "string", "title": "Fødeland" },
      "individnummer": { "type": "string", "title": "Individnummer" },
      "reinbeitedistrikt": {
        "type": "string",
        "title": "Reinbeitedistriktnummer"
      },
      "alder": { "type": "string", "title": "Aldersgruppe" },
      "kjoenn": { "type": "string", "title": "Kjønnskode" }
    }
  },
  "subSampleId": {
    "type": "integer",
    "title": "Delprøvenummer",
    "description": "Fyll inn delprøvenummeret. Denne skal være unik for hver delprøve.",
    "minimum": 0,
    "maximum": 999
  },
  "subSamplesStorfe": {
    "type": "array",
    "title": "Delprøver (storfe)",
    "description": "Ved å scanne skrottlappen vil noen av feltene i skjemaet utfylles automatisk, resten kan fylles ut manuelt. Scan den nederste strekkoden hvis skrottlappen har to strekkoder. Husk å sjekke at informasjonen stemmer.",
    "minItems": 1,
    "uniqueItems": true,
    "items": {
      "type": "object",
      "required": ["subSampleId", "payload"],
      "properties": {
        "subSampleId": {
          "$ref": "#/definitions/subSampleId"
        },
        "payload": {
          "type": "object",
          "title": "Tilleggsinformasjon om delprøve",
          "required": ["entityId"],
          "properties": {
            "entityId": {
              "$ref": "#/definitions/entityId"
            },
            "skrottlappScan": {
              "$ref": "#/definitions/skrottlappScanStorfe"
            }
          }
        }
      }
    }
  },
  "subSamplesSvinSlakteri": {
    "type": "array",
    "title": "Delprøver (svin), slakteri",
    "description": "Ved å scanne skrottlappen vil noen av feltene i skjemaet utfylles automatisk, resten kan fylles ut manuelt. Scan den nederste strekkoden hvis skrottlappen har to strekkoder. Husk å sjekke at informasjonen stemmer.",
    "minItems": 1,
    "uniqueItems": true,
    "items": {
      "type": "object",
      "required": ["subSampleId", "payload"],
      "properties": {
        "subSampleId": {
          "$ref": "#/definitions/subSampleId"
        },
        "payload": {
          "type": "object",
          "title": "Tilleggsinformasjon om delprøve",
          "required": ["entityId"],
          "properties": {
            "entityId": {
              "type": "string",
              "title": "Individnummer",
              "description": "Fyll inn 8 første siffer av produsentnummer + individnummer, 4 eller 5 siffer.",
              "pattern": "([0-9]{12}|[0-9]{13})",
              "maxLength": 13
            },
            "skrottlappScan": {
              "$ref": "#/definitions/skrottlappScanSvin"
            }
          }
        }
      }
    }
  },
  "subSamplesSvinAnlegg": {
    "type": "array",
    "title": "Delprøver (svin), anlegg",
    "description": "Fyll inn delprøvenummeret. Denne skal være unik for hver delprøve. Individnummer er 8 første siffer av produsentnummer + individnummer, 4 eller 5 siffer.",
    "minItems": 1,
    "uniqueItems": true,
    "items": {
      "type": "object",
      "required": ["subSampleId", "payload"],
      "properties": {
        "subSampleId": {
          "$ref": "#/definitions/subSampleId"
        },
        "payload": {
          "type": "object",
          "title": "Tilleggsinformasjon om delprøve",
          "required": ["entityId"],
          "properties": {
            "entityId": {
              "type": "string",
              "title": "Individnummer",
              "description": "Fyll inn 8 første siffer av produsentnummer + individnummer, 4 eller 5 siffer.",
              "pattern": "([0-9]{12}|[0-9]{13})",
              "maxLength": 13
            }
          }
        }
      }
    }
  },
  "subSamplesNumber": {
    "type": "string",
    "title": "Antall delprøver",
    "description": "Velg antall delprøver.",
    "oneOf": [
      { "const": "10", "title": "10" },
      { "const": "30", "title": "30" },
      { "const": "50", "title": "50" },
      { "const": "60", "title": "60" }
    ]
  },
  "eftakode": {
    "type": "string",
    "title": "EFTA-nummer",
    "description": "Fyll inn EFTA-nummeret for slakteriet.",
    "minLength": 3,
    "maxLength": 4
  },
  "kommunenr": {
    "type": "string",
    "title": "Kommunenr",
    "description": "Fyll inn kommunenummer på 4 siffer.",
    "minLength": 4,
    "maxLength": 4,
    "pattern": "^[0-9]{4}$"
  },
  "typeSvinebesetning": {
    "type": "string",
    "title": "Type svinebesetning",
    "description": "Velg “Andre” kun når du ikke kan finne svaret.",
    "enum": [
      "Avlsbesetning",
      "Purkering",
      "Slaktegrisbesetning",
      "Andre besetninger"
    ]
  },
  "takenDate": {
    "type": "string",
    "format": "date",
    "title": "Uttaksdato"
  },
  "lokalitet": {
    "type": "object",
    "title": "Velg lokalitet",
    "properties": {
      "externalReferenceId": {
        "type": "string",
        "title": "Lokalitetsnummer"
      },
      "organisasjonsnummer": {
        "type": "string",
        "title": "Organisasjonsnummer"
      },
      "virksomhetsnavn": {
        "type": "string",
        "title": "Virksomhetsnavn"
      }
    },
    "required": ["externalReferenceId", "organisasjonsnummer"]
  },
  "produsent": {
    "type": "object",
    "title": "Velg produsent",
    "description": "Søk og velg produsenten som er ansvarlig for dyret eller produktet prøven er tatt av. Du kan søke etter navn på virksomhet eller produsentnummer.",
    "properties": {
      "externalReferenceId": {
        "type": "string",
        "title": "Produsentnummer"
      },
      "organisasjonsnummer": {
        "type": "string",
        "title": "Organisasjonsnummer"
      },
      "virksomhetsnavn": {
        "type": "string",
        "title": "Virksomhetsnavn"
      },
      "tilsynsobjektId": {
        "type": "string",
        "title": "Tilsynsobjekt-ID"
      },
      "aktivitet": {
        "type": "string",
        "title": "Aktivitet"
      }
    },
    "required": ["tilsynsobjektId"]
  },
  "nameRedacted": {
    "type": "string",
    "title": "Inneholder virksomhetsnavnet kun personnavn",
    "description": "Virksomhetsnavn som kun inneholder personnavn skal skjermes jf. Offentlegforskrifta § 6 fjerde ledd",
    "oneOf": [
      { "const": "No", "title": "Nei" },
      { "const": "Yes", "title": "Ja" }
    ]
  },
  "comment": {
    "type": "string",
    "title": "Kommentar",
    "description": "Hvis du ønsker å legge igjen en kommentar til deg selv, kan dette gjøres her. Kommentaren sendes ikke til laboratoriet.",
    "maxLength": 1000
  },
  "produksjonstype": {
    "type": "string",
    "title": "Produksjonstype",
    "oneOf": [
      {
        "const": "RUGEEGG_BESTEFORELDREDYR",
        "title": "Rugeegg (besteforeldredyr)"
      },
      { "const": "RUGEEGG_FORELDREDYR", "title": "Rugeegg (foreldredyr)" },
      { "const": "RUGERI", "title": "Rugeri" },
      {
        "const": "OPPAL_BESTEFORELDREDYR",
        "title": "Oppal (besteforeldredyr)"
      },
      { "const": "OPPAL_FORELDREDYR", "title": "Oppal (foreldredyr)" },
      { "const": "OPPAL", "title": "Oppal" },
      { "const": "KONSUMEGG", "title": "Konsumegg" },
      { "const": "SLAKTEFJORFE", "title": "Slaktefjørfe" },
      { "const": "HOBBY_FJORFE", "title": "Hobby fjørfe" }
    ]
  },
  "verdikjede": {
    "type": "string",
    "title": "Verdikjede",
    "oneOf": [
      { "const": "KONSUMEGG", "title": "Konsumegg" },
      { "const": "SLAKTEFJORFE", "title": "Slaktefjørfe" },
      {
        "const": "GJENOPPBYGGE_FUGLEVILTBESTAND",
        "title": "Gjenoppbygge fugleviltbestand"
      },
      { "const": "FJOERFE", "title": "Fjørfe" },
      { "const": "FUGLER_I_FANGENSKAP", "title": "Fugler i fangenskap" }
    ]
  },
  "helseStatus": {
    "type": "string",
    "title": "Helsestatus",
    "oneOf": [
      { "const": "FRISK", "title": "Frisk" },
      { "const": "SYK", "title": "Syk" },
      { "const": "NORMALSLAKTET", "title": "Normalslaktet" },
      { "const": "ANTEMORTEM_KONTROLL", "title": "Antemortem kontroll" },
      { "const": "POSTMORTEM_KONTROLL", "title": "Postmortem kontroll" },
      { "const": "SKADET", "title": "Skadet" },
      { "const": "AVLIVET_SYK", "title": "Avlivet syk" },
      { "const": "AVLIVET_SKADET", "title": "Avlivet skadet" },
      { "const": "SELVDOED", "title": "Selvdød" },
      { "const": "NOEDSLAKTET", "title": "Nødslaktet" },
      { "const": "TRAFIKKSKADD", "title": "Trafikkskadd" },
      { "const": "TRAFIKKDREPT", "title": "Trafikkdrept" }
    ]
  },
  "hybrid": {
    "type": "string",
    "title": "Hybrid",
    "maxLength": 200
  },
  "sertifiseringspliktig": {
    "type": "string",
    "title": "Sertifiseringspliktig",
    "oneOf": [
      { "const": "No", "title": "Nei" },
      { "const": "Yes", "title": "Ja" }
    ]
  },
  "godkjenningspliktig": {
    "type": "string",
    "title": "Godkjenningspliktig",
    "oneOf": [
      { "const": "No", "title": "Nei" },
      { "const": "Yes", "title": "Ja" }
    ]
  },
  "batchnummer": {
    "type": "string",
    "title": "Batchnummer",
    "maxLength": 100,
    "description": "Nummer som definerer hvilket parti varen kommer fra"
  },
  "holdbarhetsdato": {
    "type": "string",
    "format": "date",
    "title": "Holdbarhetsdato",
    "description": "Dato for når varen ikke lenger anses som konsumerbar"
  },
  "hasteNoedslakt": {
    "type": "string",
    "title": "Haste-/nødslakt",
    "description": "I urinprøver av dyr som ikke er planlagt å slaktes, kan vi avsløre ulovlig bruk av legemidler. Derfor kan også urinprøven tas av nødslakt eller hasteslakt.",
    "oneOf": [
      { "const": "No", "title": "Nei" },
      { "const": "Yes", "title": "Ja" }
    ]
  },
  "fysioStadium": {
    "type": "string",
    "title": "Fysiologisk stadium",
    "oneOf": [
      { "const": "Yngel_parr_unger", "title": "Yngel/parr/unger" },
      { "const": "Smolt", "title": "Smolt" },
      { "const": "Matfisk", "title": "Matfisk" },
      { "const": "Annet", "title": "Annet" }
    ]
  },
  "sisteEktoparasittbehandling": {
    "type": "string",
    "title": "Siste ektoparasittbehandling",
    "format": "date"
  },
  "vanntemperatur": {
    "type": "number",
    "title": "Vanntemperatur",
    "maximum": 40
  },
  "driftsform": {
    "type": "string",
    "title": "Driftsform",
    "oneOf": [
      { "const": "Matfisk_i_ferskvann", "title": "Matfisk i ferskvann" },
      { "const": "Settefiskanlegg", "title": "Settefiskanlegg" },
      { "const": "Kultiveringsanlegg", "title": "Kultiveringsanlegg" }
    ]
  },
  "smaskaletProduksjon": {
    "type": "string",
    "title": "Småskalet produksjon direkte til detaljist/forbruker",
    "description": "Velg om produksjonen er småskalet og går direkte til detaljist eller forbruker.",
    "oneOf": [
      { "const": "No", "title": "Nei" },
      { "const": "Yes", "title": "Ja" }
    ]
  },
  "honsType": {
    "type": "string",
    "title": "Frittgående/burhøns",
    "description": "Velg om hønene er frittgående eller burhøns.",
    "oneOf": [
      { "const": "FRITTGAAENDE", "title": "Frittgående" },
      { "const": "BURHONS", "title": "Burhøns" }
    ]
  },
  "importert": {
    "type": "string",
    "title": "Importert",
    "description": "Velg om dyret er importert.",
    "oneOf": [
      { "const": "No", "title": "Nei" },
      { "const": "Yes", "title": "Ja" }
    ]
  },
  "purkeEllerRane": {
    "type": "string",
    "title": "Purke/råne",
    "description": "Velg om dyret er purke eller råne.",
    "oneOf": [
      { "const": "PURKE", "title": "Purke" },
      { "const": "RAANE", "title": "Råne" }
    ]
  },
  "produksjonstypeStorfe": {
    "type": "string",
    "title": "Produksjonstype",
    "description": "Velg produksjonstype for storfe.",
    "oneOf": [
      { "const": "KJOTTFE_AMMEKU", "title": "Kjøttfe (ammeku)" },
      { "const": "MJOLKEKU", "title": "Mjølkeku" }
    ]
  },
  "verdikjedeStorfe": {
    "type": "string",
    "title": "Verdikjede",
    "description": "Velg verdikjede for storfe.",
    "oneOf": [
      { "const": "KJOTTPRODUKSJON", "title": "Kjøttproduksjon" },
      { "const": "MELKEPRODUKSJON", "title": "Melkeproduksjon" }
    ]
  },
  "produksjonstypeSvin": {
    "type": "string",
    "title": "Produksjonstype",
    "description": "Velg produksjonstype for svin.",
    "oneOf": [
      {
        "const": "AVLSBESETNING_FOREDLING",
        "title": "Avlsbesetning foredlingsbesetninger"
      },
      {
        "const": "AVLSBESETNING_FORMERING",
        "title": "Avlsbesetning formeringsbesetninger"
      },
      { "const": "NAV", "title": "Nav" },
      { "const": "SATELLITT", "title": "Satellitt" },
      { "const": "BRUKSBESETNING_SMAGRIS", "title": "Bruksbesetning smågris" },
      {
        "const": "BRUKSBESETNING_KOMBINERT",
        "title": "Bruksbesetning kombinert"
      },
      {
        "const": "BRUKSBESETNING_SLAKTEGRIS",
        "title": "Bruksbesetning slaktegris"
      },
      { "const": "SEMINSTASJON", "title": "Seminstasjon" }
    ]
  },
  "produksjonstypeAkva": {
    "type": "string",
    "title": "Produksjonstype",
    "oneOf": [
      { "const": "Matfisk_i_ferskvann", "title": "Matfisk i ferskvann" },
      { "const": "Settefiskanlegg", "title": "Settefiskanlegg" },
      { "const": "Kultiveringsanlegg", "title": "Kultiveringsanlegg" },
      { "const": "Villfisk", "title": "Villfisk" }
    ]
  },
  "verdikjedeSvin": {
    "type": "string",
    "title": "Verdikjede",
    "description": "Velg verdikjede for svin.",
    "oneOf": [
      { "const": "AVLSDYR", "title": "Avlsdyr" },
      { "const": "HOBBY", "title": "Hobby" },
      { "const": "SMAGRIS", "title": "Smågris" },
      { "const": "SLAKTEGRIS", "title": "Slaktegris" },
      { "const": "DREKTIGE_PURKER", "title": "Drektige purker" },
      { "const": "AVLSPRODUKTER", "title": "Avlsprodukter" }
    ]
  },
  "melkStorfeProver": {
    "type": "string",
    "title": "Melk storfe",
    "description": "Velg type melk tatt fra storfe.",
    "oneOf": [
      { "const": "TANKMELK", "title": "Tankmelk" },
      { "const": "MELK_ENKELTINDIVID", "title": "Melk fra enkeltindivid" }
    ]
  },
  "forbehandling": {
    "type": "object",
    "title": "Forbehandling",
    "description": "Velg hvordan prøven er forbehandlet.",
    "required": ["nivaa2"],
    "properties": {
      "nivaa2": {
        "type": "string",
        "title": "Forbehandling",
        "oneOf": [
          { "const": "UBEHANDLET", "title": "Ubehandlet" },
          { "const": "KJOELT", "title": "Kjølt" },
          { "const": "FROSSET", "title": "Frosset" },
          { "const": "VARMEBEHANDLET", "title": "Varmebehandlet" },
          { "const": "TOERKET", "title": "Tørket" },
          { "const": "BESTRAALT", "title": "Bestrålt" },
          { "const": "DESINFISERT", "title": "Desinfisert" },
          { "const": "INAKTIVERT", "title": "Inaktivert" },
          { "const": "STERILISERT", "title": "Sterilisert" },
          { "const": "REGULERT_ATMOSFAERE", "title": "Regulert atmosfære" },
          { "const": "VAKUUMPAKKET", "title": "Vakuumpakket" },
          { "const": "EKSTRAHERT", "title": "Ekstrahert" },
          { "const": "HOMOGENISERT", "title": "Homogenisert" },
          { "const": "MALT", "title": "Malt" },
          { "const": "SALTET", "title": "Saltet" },
          { "const": "FIKSERT", "title": "Fiksert" },
          {
            "const": "SENDT_I_TRANSPORTMEDIUM",
            "title": "Sendt i transportmedium"
          },
          {
            "const": "SENDT_MED_HEMMENDE_REGULERENDE_TILSETNING",
            "title": "Sendt med hemmende/regulerende tilsetning"
          },
          { "const": "PREPARERT_SNITT", "title": "Preparert snitt" },
          { "const": "PREPARERT_BLOKK", "title": "Preparert blokk" },
          { "const": "ADSORBERT", "title": "Adsorbert" },
          {
            "const": "BEHANDLET_MED_RDE",
            "title": "Behandlet med RDE (Reseptor Destroying Enzyme)"
          }
        ]
      }
    },
    "not": {
      "required": ["nivaa2", "nivaa3"],
      "properties": {
        "nivaa2": {
          "enum": [
            "UBEHANDLET",
            "KJOELT",
            "DESINFISERT",
            "STERILISERT",
            "VAKUUMPAKKET",
            "HOMOGENISERT",
            "MALT",
            "SALTET",
            "PREPARERT_BLOKK",
            "ADSORBERT",
            "BEHANDLET_MED_RDE"
          ]
        }
      }
    },
    "allOf": [
      {
        "if": {
          "properties": { "nivaa2": { "const": "FROSSET" } },
          "required": ["nivaa2"]
        },
        "then": {
          "properties": {
            "nivaa3": {
              "type": "string",
              "title": "Velg spesifisering",
              "oneOf": [
                {
                  "const": "FROSSET_CA_MINUS_20",
                  "title": "Frosset ved ca. -20 °C"
                },
                {
                  "const": "FROSSET_CA_MINUS_70_80",
                  "title": "Frosset ved ca. -70-80 °C"
                },
                {
                  "const": "FROSSET_FLYTENDE_NITROGEN",
                  "title": "Frosset i flytende nitrogen"
                }
              ]
            }
          },
          "required": ["nivaa3"]
        }
      },
      {
        "if": {
          "properties": { "nivaa2": { "const": "VARMEBEHANDLET" } },
          "required": ["nivaa2"]
        },
        "then": {
          "properties": {
            "nivaa3": {
              "type": "string",
              "title": "Velg spesifisering",
              "oneOf": [
                { "const": "VARMETRANSPORTERT", "title": "Varmetransportert" }
              ]
            }
          },
          "required": ["nivaa3"]
        }
      },
      {
        "if": {
          "properties": { "nivaa2": { "const": "TOERKET" } },
          "required": ["nivaa2"]
        },
        "then": {
          "properties": {
            "nivaa3": {
              "type": "string",
              "title": "Velg spesifisering",
              "oneOf": [
                { "const": "FRYSETOERKET", "title": "Frysetørket" },
                { "const": "VARMETOERKET", "title": "Varmetørket" }
              ]
            }
          },
          "required": ["nivaa3"]
        }
      },
      {
        "if": {
          "properties": { "nivaa2": { "const": "BESTRAALT" } },
          "required": ["nivaa2"]
        },
        "then": {
          "properties": {
            "nivaa3": {
              "type": "string",
              "title": "Velg spesifisering",
              "oneOf": [{ "const": "UV_BESTRAALT", "title": "UV-bestrålt" }]
            }
          },
          "required": ["nivaa3"]
        }
      },
      {
        "if": {
          "properties": { "nivaa2": { "const": "INAKTIVERT" } },
          "required": ["nivaa2"]
        },
        "then": {
          "properties": {
            "nivaa3": {
              "type": "string",
              "title": "Velg spesifisering",
              "oneOf": [
                { "const": "VARMEINAKTIVERT", "title": "Varmeinaktivert" }
              ]
            }
          },
          "required": ["nivaa3"]
        }
      },
      {
        "if": {
          "properties": { "nivaa2": { "const": "REGULERT_ATMOSFAERE" } },
          "required": ["nivaa2"]
        },
        "then": {
          "properties": {
            "nivaa3": {
              "type": "string",
              "title": "Velg spesifisering",
              "oneOf": [
                { "const": "INERT_ATMOSFAERE", "title": "Inert atmosfære" },
                {
                  "const": "MODIFISERT_ATMOSFAERE",
                  "title": "Modifisert atmosfære"
                }
              ]
            }
          },
          "required": ["nivaa3"]
        }
      },
      {
        "if": {
          "properties": { "nivaa2": { "const": "EKSTRAHERT" } },
          "required": ["nivaa2"]
        },
        "then": {
          "properties": {
            "nivaa3": {
              "type": "string",
              "title": "Velg spesifisering",
              "oneOf": [
                { "const": "RNA_DNA_EKSTRAKT", "title": "RNA/DNA-ekstrakt" },
                { "const": "NA_EKSTRAKT", "title": "NA-ekstrakt" }
              ]
            }
          },
          "required": ["nivaa3"]
        }
      },
      {
        "if": {
          "properties": { "nivaa2": { "const": "FIKSERT" } },
          "required": ["nivaa2"]
        },
        "then": {
          "properties": {
            "nivaa3": {
              "type": "string",
              "title": "Velg spesifisering",
              "oneOf": [
                { "const": "FORMALIN", "title": "Formalin" },
                { "const": "ALKOHOL", "title": "Alkohol" },
                {
                  "const": "KARNOWSKY_GLUTARALDEHYD",
                  "title": "Karnowsky-/glutaraldehyd"
                }
              ]
            }
          },
          "required": ["nivaa3"]
        }
      },
      {
        "if": {
          "properties": { "nivaa2": { "const": "SENDT_I_TRANSPORTMEDIUM" } },
          "required": ["nivaa2"]
        },
        "then": {
          "properties": {
            "nivaa3": {
              "type": "string",
              "title": "Velg spesifisering",
              "oneOf": [
                { "const": "VANN", "title": "Vann" },
                {
                  "const": "FYSIOLOGISK_SALTVANN",
                  "title": "Fysiologisk saltvann"
                },
                { "const": "BUFFER", "title": "Buffer" },
                { "const": "BULJONG", "title": "Buljong" },
                { "const": "RNALATER", "title": "RNAlater" },
                { "const": "LANDERS", "title": "Lander's" }
              ]
            }
          },
          "required": ["nivaa3"]
        }
      },
      {
        "if": {
          "properties": {
            "nivaa2": {
              "const": "SENDT_MED_HEMMENDE_REGULERENDE_TILSETNING"
            }
          },
          "required": ["nivaa2"]
        },
        "then": {
          "properties": {
            "nivaa3": {
              "type": "string",
              "title": "Velg spesifisering",
              "oneOf": [
                { "const": "BRONOPOL", "title": "Bronopol" },
                { "const": "SYRE", "title": "Syre" },
                { "const": "AMMONIAKK", "title": "Ammoniakk" },
                { "const": "KLOR", "title": "Klor" }
              ]
            }
          },
          "required": ["nivaa3"]
        }
      },
      {
        "if": {
          "properties": { "nivaa2": { "const": "PREPARERT_SNITT" } },
          "required": ["nivaa2"]
        },
        "then": {
          "properties": {
            "nivaa3": {
              "type": "string",
              "title": "Velg spesifisering",
              "oneOf": [
                {
                  "const": "PARAFININNSTOEPT_SNITT",
                  "title": "Parafininnstøpt snitt"
                },
                { "const": "FIKSERT_SNITT", "title": "Fiksert snitt" },
                { "const": "FRYSESNITT", "title": "Frysesnitt" }
              ]
            }
          },
          "required": ["nivaa3"]
        }
      }
    ]
  },
  "BSEStatus": {
    "type": "string",
    "title": "BSE status",
    "description": "Velg BSE status for storfe.",
    "oneOf": [
      { "const": "BSE_A", "title": "BSE (A) Klinisk mistanke (ikke OK)" },
      {
        "const": "BSE_B",
        "title": "BSE (B) Antemortemdyr med adferdstegn/nevrologiske tegn"
      },
      {
        "const": "BSE_C",
        "title": "BSE (C) Avlivet pga adferdstegn/nevrologiske tegn (ikke klinisk mistanke)"
      },
      {
        "const": "BSE_D",
        "title": "BSE (D) Selvdød og har hatt adferdstegn/nevrologiske tegn (ikke klinisk mistanke)"
      },
      {
        "const": "BSE_E",
        "title": "BSE (E) Avlivet/selvdød storfe > 48 måneder (ikke D eller C)"
      },
      { "const": "BSE_F", "title": "BSE (F) Antemortemdyr > 48 mnd (ikke B)" },
      { "const": "BSE_G", "title": "BSE (G) Nødslakt > 48 mnd" },
      { "const": "BSE_H", "title": "BSE (H) Importert storfe" }
    ]
  },
  "vassdrag": {
    "type": "object",
    "title": "Vassdrag",
    "description": "Velg vassdrag fra liste over elver i nærheten eller skriv inn manuelt.",
    "properties": {
      "vassdragsnummer": {
        "type": "string",
        "title": "Vassdragsnummer",
        "description": "Fyll inn vassdragsnummer.",
        "minLength": 1,
        "pattern": "^.*\\S.*$"
      },
      "elvenavn": {
        "type": "string",
        "title": "Elvenavn",
        "description": "Fyll inn navn på elv/vassdrag."
      }
    },
    "required": ["vassdragsnummer"]
  },
  "reinbeitedistrikt": {
    "type": "object",
    "title": "Reinbeitedistrikt",
    "description": "Velg reinbeitedistrikt.",
    "required": ["codevalue", "label"],
    "properties": {
      "codevalue": {
        "type": "string",
        "title": "Distriktskode",
        "minLength": 1
      },
      "label": {
        "type": "string",
        "title": "Navn",
        "minLength": 1
      }
    }
  }
}
